import ApplicationSerializer from './application';
import { service } from '@ember/service';

export default class DeskSerializer extends ApplicationSerializer {
  @service store;
  @service state;

  serialize(snapshot) {
    const json = super.serialize(...arguments);

    if (snapshot.record.floorId) {
      json.data.relationships = {
        ...json.data.relationships,
        floor: {
          data: {
            id: snapshot.record.floorId,
            type: 'floors',
          },
        },
      };
    }

    const neighborhoodId = json?.data?.relationships?.neighborhood?.data?.id;

    if (neighborhoodId) {
      json.data.attributes['neighborhood-id'] = neighborhoodId;
    } else {
      json.data.attributes['neighborhood-id'] = null;
    }

    return json;
  }

  normalizeFindHasManyResponse(store, model, payload) {
    delete payload.errors;
    return super.normalizeFindHasManyResponse(...arguments);
  }

  normalizeQueryResponse(store, model, payload) {
    delete payload.errors;
    return super.normalizeFindHasManyResponse(...arguments);
  }
}
